export const rechargeHistoryHeadCells = [
    { id: 'id', numeric: true, disablePadding: false, align: 'left', label: 'ID' },
    { id: 'transaction_date', numeric: false, disablePadding: false, label: 'Transaction Date' },
    { id: 'amount_in_inr', numeric: false, disablePadding: false, label: 'Amount in INR' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
    { id: 'remarks', numeric: false, disablePadding: false, label: 'Remarks' }
];

export const bookingTargetHeadCells = [
    { id: 'target', numeric: true, disablePadding: false, align: 'left', label: 'Target' },
    { id: 'target_month', numeric: false, disablePadding: false, label: 'Target Month' },
    { id: 'created_by', numeric: false, disablePadding: false, label: 'Created By' },
    { id: 'created_at', numeric: false, disablePadding: false, label: 'Created At' }
];

export const VIEW_TYPE_MPD_VIEW = 'member-priority-dashboard';
export const MODULE_ACCESS_MEMBER_DETAILS = 'MEMBER_DETAILS';
export const MODULE_ACCESS_ORGANIZATION_DETAILS = 'ORGANIZATION_DETAILS';
export const MODULE_ACCESS_RECHARGE_HISTORY = 'VIEW_RECHARGE_HISTORY';
